import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import GallerySection from '../components/GallerySection';
import WaveDivider from '../components/WaveDivider';

export default function ReferenceDetailPage() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <SEO
        title="Reference | JT transportsejlads"
        description="Se flere af vores projekter og referencer her."
        ogTitle="Reference | JT transportsejlads"
        ogDescription="Se flere af vores projekter og referencer her."
        ogImage="https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1266713739_aabbbf38.jpg"
      />

      {/* Page Header */}
      <section className="relative bg-maritime-950 text-white pt-32 pb-20 lg:pt-36 lg:pb-24 overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-45">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg"
            alt="Reference sejlads og bådtransport"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-maritime-950 via-maritime-950/80 to-maritime-950/60" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white mb-6">
            Reference
          </h1>

          <p className="text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto">
            Se flere af vores projekter og referencer her.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-sm">
            <a
              href="tel:+4550510062"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15 text-white border border-white/20 whitespace-nowrap transition-colors"
            >
              <i className="fa-solid fa-phone text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap font-medium">+45 50 51 00 62</span>
            </a>
            <a
              href="mailto:johann2@hotmail.com"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15 text-white border border-white/20 whitespace-nowrap transition-colors"
            >
              <i className="fa-solid fa-envelope text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap font-medium">johann2@hotmail.com</span>
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 inset-x-0">
          <WaveDivider fill="#f8fafc" />
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-16 sm:py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* Section: Skræddersyede løsninger */}
          <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-sm border border-slate-200/80 space-y-6">
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
              Skræddersyede løsninger
            </h2>

            <p className="text-slate-700 text-base sm:text-lg leading-relaxed">
              Vores kunder har alle forskellige behov, og derfor tilbyder vi altid skræddersyede løsninger med udgangspunkt i hver enkelte kundes ønsker. Inden vi går i gang, forventningsafstemmer vi med dig, så vi kan levere et resultat, der lever op til dine forventninger. Se vores projekter og referencer her.
            </p>
          </div>

          {/* Section: Kompetent rådgivning */}
          <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-sm border border-slate-200/80 space-y-6">
            <div className="w-12 h-12 rounded-xl bg-cyan-50 text-cyan-600 flex items-center justify-center text-xl">
              <i className="fa-solid fa-compass" aria-hidden="true" />
            </div>

            <h3 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
              Kompetent rådgivning
            </h3>

            <p className="text-slate-700 text-base sm:text-lg leading-relaxed">
              Er du i tvivl om, hvilken løsning der er den bedste for dig? Det skal du ikke bekymre dig om. Vi tilbyder kompetent rådgivning i forbindelse med ethvert projekt og holder dig opdateret fra start til slut. Du er i trygge hænder hos os.
            </p>
          </div>

          {/* Scrape Image Feature */}
          <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200 bg-white">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1266713739.jpg"
              alt="JT transportsejlads reference og udført projekt"
              className="w-full h-auto max-h-[500px] object-cover"
              loading="lazy"
              width="1000"
              height="600"
            />
          </div>

          {/* CTA Box */}
          <div className="bg-maritime-900 text-white rounded-2xl p-8 sm:p-10 shadow-xl border border-maritime-800 text-center space-y-4">
            <h3 className="text-2xl font-bold text-white tracking-tight">
              Har du en opgave til mig?
            </h3>
            <p className="text-slate-300 max-w-xl mx-auto text-sm sm:text-base">
              Kontakt mig i dag for en uforpligtende snak om din transport af båd.
            </p>
            <div className="pt-2 flex flex-wrap justify-center gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 text-white font-semibold text-sm transition-colors shadow-md"
              >
                <span>Gå til kontakt</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
              <Link
                to="/referencer"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-white/10 hover:bg-white/15 text-white font-semibold text-sm border border-white/20 transition-colors"
              >
                <span>Tilbage til alle referencer</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Connected CMS Gallery */}
      <GallerySection
        gallerySlug="referencer-galleri"
        title="Projekter & Referencer"
        subtitle="Flere billeder fra mit arbejde på vandet og i havnene"
      />
    </div>
  );
}
